import { createAction } from 'redux-actions';
import getNotificationPreferences from 'ui-forms-editor-automation-lib/api/getNotificationPreferences';
import getNotificationPreferencesRequestState from 'ui-forms-editor-automation-lib/selectors/notificationPreferences/getNotificationPreferencesRequestState';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
export const REQUEST_NOTIFICATION_PREFERENCES = '@@lib/REQUEST_NOTIFICATION_PREFERENCES';
export const RECEIVE_NOTIFICATION_PREFERENCES = '@@lib/RECEIVE_NOTIFICATION_PREFERENCES';
export const FAIL_GETTING_NOTIFICATION_PREFERENCES = '@@lib/FAIL_GETTING_NOTIFICATION_PREFERENCES';
const requestNotificationPreferences = createAction(REQUEST_NOTIFICATION_PREFERENCES);
const receiveNotificationPreferences = createAction(RECEIVE_NOTIFICATION_PREFERENCES);
const failGettingNotificationPreferences = createAction(FAIL_GETTING_NOTIFICATION_PREFERENCES);
const fetchNotificationPreferences = () => (dispatch, getState) => {
  const state = getState();
  const applicationName = getApplicationName(state);
  if (!getNotificationPreferencesRequestState(state).shouldBeRequested()) {
    return Promise.resolve();
  }
  let apiFunctionToCall;
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      apiFunctionToCall = getNotificationPreferences();
      break;
    case APPLICATION_NAMES.FORMSUI:
    default:
      apiFunctionToCall = getNotificationPreferences();
      break;
  }
  dispatch(requestNotificationPreferences());
  apiFunctionToCall.then(preferences => {
    dispatch(receiveNotificationPreferences(preferences));
  }).catch(() => {
    dispatch(failGettingNotificationPreferences());
  });
  return undefined;
};
export default fetchNotificationPreferences;